import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { webPaths } from '../../routes/paths';
import Helmet from '../../components/Helmet';
import CountrySelection from '../../components/CountrySelection';
import { useGetMyProfileQuery } from '../../services/users';

export interface HomeProps extends MuiBoxProps {}

export const StudentCountry = ({ className }: HomeProps) => {
  const navigate = useNavigate();

  const {
    data: user,
    isLoading: loadingUser,
    isUninitialized: uninitialisedUser,
  } = useGetMyProfileQuery();

  useEffect(() => {
    if (!user && !loadingUser && !uninitialisedUser) {
      localStorage.removeItem('token');
      navigate(`${webPaths.root}`, { replace: true });
    }
  }, [user]);

  return (
    <>
      <Helmet />

      <CountrySelection />
    </>
  );
};

StudentCountry.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

StudentCountry.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(StudentCountry)(
  ({ theme }) => `
`,
);
